import React from "react";
const service = require("../../../public/service.json");

const GlobalErrorPopup = ({ onClickClose }) => {
  return (
    <>
      <div className="email-verification">
        <div className="modal-bg-centered" id="popup-bg" />
        <div className="modal">
          <div className="add-item-page">
            <div className="head-general with-back visible-xs">
              <a />
              <h4>Opps!</h4>
              <a onClick={onClickClose} className="close">
                <icon className="icon icon-close" />
              </a>
            </div>
            <div className="container we-right-back-modal">
              <div className="head-general with-back hide-xs">
                <a className="back"></a>
                <h4></h4>
                <a onClick={onClickClose} className="close cursor-pointer">
                  <i className="icon icon-close"></i>
                </a>
              </div>
              <h4>{service.downTitle}</h4>
              <div>
                <p>{service.downMessage}</p>
                <p className="hashtag">#thankyou</p>
              </div>
              <div className="svg">
                <img src="/png/we-right.png" alt="" />
              </div>
              <a href={service.downRedirectUrl || "/"} className="btn btn-blue">
                Back to homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalErrorPopup;
